import Grid from '@mui/material/Grid';
import { _ } from '/@/locale';
import Dots from '/@/v3/components/dots';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

export const NewDotsReference = ({ brand, country }) => {
    return (
        <Grid container direction='column'>
            <Grid item xs={4} sx={{ width: '100%' }}>
                <div className={styles.container}>
                    <Dots max={brand.metricsMaxValue} reference showValues={country.code !== 'BR'} />
                    <div className={styles.references}>
                        <Title className={styles.title} size='sm'>
                            {_('Tolerante')}
                        </Title>
                        <div className={styles.firstDivider} />
                        <Title className={styles.title} size='sm'>
                            {_('Moderado')}
                        </Title>
                        <div className={styles.secondDivider} />
                        <Title className={styles.title} size='sm'>
                            {_('Susceptible')}
                        </Title>
                    </div>
                </div>
            </Grid>
        </Grid>
    );
};
